import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  SortableContext,
  verticalListSortingStrategy,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'
import { LimitTypeEnum } from 'src/model/limit'
import { getUserLimits } from 'src/api/limit'

import CourseCard from 'src/components/course-card'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  closestCorners,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import LimitReachedModal from 'src/components/limit-reached-modal'

import { editCourseCollectionIndexAction } from 'src/reducers/collection/action'
import { useParams } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
const CourseView = props => {
  const { classes, courses, searchTerm } = props

  const dispatch = useDispatch()
  const history = useHistory()
  const { id } = useParams()

  const [localCourses, setLocalCourses] = useState()

  useEffect(() => {
    if (courses !== undefined) {
      setLocalCourses(courses)
    }
  }, [courses])

  function arrayMove(arr, fromIndex, toIndex) {
    const element = arr[fromIndex]
    arr.splice(fromIndex, 1)
    arr.splice(toIndex, 0, element)
    return arr
  }

  const [changedCourses, setChangedCourses] = React.useState([])

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  const handleDragMove = useCallback(
    event => {
      const { active, over } = event

      if (
        active.id.toString().includes('item') &&
        over?.id.toString().includes('item') &&
        active &&
        over &&
        active.id !== over.id
      ) {
        const activeId = active.id.toString().split('-item')[0]
        const overId = over.id.toString().split('-item')[0]

        const activeCourse = localCourses.find(
          course => course.id.toString() === activeId,
        )
        const overCourse = localCourses.find(
          course => course.id.toString() === overId,
        )
        if (!activeCourse || !overCourse) {
          return
        }

        const activeitemIndex = activeCourse.courseCollectionOrder
        const overitemIndex = overCourse.courseCollectionOrder

        let reorderedCourses = arrayMove(
          localCourses,
          activeitemIndex,
          overitemIndex,
        )
        reorderedCourses = reorderedCourses.map((course, index) => {
          return {
            ...course,
            courseCollectionOrder: index,
            courseCollectionId: id,
          }
        })
        setLocalCourses(reorderedCourses)
        setChangedCourses(reorderedCourses)
      }
    },
    [localCourses],
  )

  const handleDragStart = event => {
    const { active } = event
    const { id } = active
  }

  const handleDragEnd = () => {
    if (localCourses.length !== 0) {
      dispatch(
        editCourseCollectionIndexAction({
          courseDtos: localCourses,
        }),
      )
      setChangedCourses([])
    }
  }
  const [modalOpen, setModalOpen] = useState(false)
  const handleRedirect = () => {
    if (isLoadingLimit) {
      setModalOpen(true)
      return
    }
    history.push('/create-course-selection?collectionId=' + id)
  }

  const [isUserReachedCourseLimit, setIsUserReachedCourseLimit] = useState(
    'Initial',
  )
  const [isLoadingLimit, setIsLoadingLimit] = useState(true)

  const collection = useSelector(state => state.collection.collection)
  useEffect(() => {
    const checkUserLimits = async () => {
      try {
        setIsLoadingLimit(true)
        const response = await getUserLimits()
        let count = response.data.find(
          x => x.limit.type == LimitTypeEnum.CourseCreation,
        ).count

        let limit = response.data.find(
          x => x.limit.type == LimitTypeEnum.CourseCreation,
        ).limit.upperLimit

        count >= limit && limit != -1
          ? setIsUserReachedCourseLimit(true)
          : setIsUserReachedCourseLimit(false)
      } catch (error) {
        console.error('Error checking user limits:', error)
        setIsUserReachedCourseLimit(false)
      } finally {
        setIsLoadingLimit(false)
      }
    }
    checkUserLimits()
  }, [])
  if (localCourses == null || courses == null) {
    return null
  }
  const entity = collection

  return (
    <div
      className={clsx({
        [classes.container]: localCourses.length > 0,
        [classes.noCoursesContainer]: localCourses.length == 0,
      })}
    >
      {localCourses.length > 0 ? (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCorners}
          onDragEnd={handleDragEnd}
          onDragMove={handleDragMove}
          onDragStart={handleDragStart}
          strategy={verticalListSortingStrategy}
        >
          <SortableContext
            items={localCourses.map(course => `${course.id}-item`)}
          >
            {localCourses.map((course, index) => (
              <CourseCard
                key={course.id}
                course={course}
                index={index}
                setLocalCourses={setLocalCourses}
                localCourses={localCourses}
              />
            ))}
          </SortableContext>
        </DndContext>
      ) : (
        (localCourses !== undefined || localCourses.length === 0) && (
          <div className={classes.noCourses}>
            <img alt="no courses view" src="/assets/no-mini-courses.svg" />
            <Typography className={classes.noCoursesText}>
              {!(searchTerm === '' || searchTerm === undefined) ? (
                <>
                  No <span className={classes.blueText}>mini course</span> found
                  matching your search.
                </>
              ) : (
                <>
                  There is no{' '}
                  <span className={classes.blueText}>mini course</span> yet.
                </>
              )}
            </Typography>
            <Typography className={classes.noCoursesDescriptionText}>
              {!(searchTerm === '' || searchTerm === undefined)
                ? 'Try adjusting your search terms or browse all courses.'
                : 'Use the AI Assistant to generate a Mini-Course or quiz super-fast, or create from scratch.'}
            </Typography>
            {(searchTerm === '' || searchTerm === undefined) && (
              <CoreButton
                startIcon={<Icon icon="mdi:plus" />}
                onClick={handleRedirect}
              >
                Create your first mini course
              </CoreButton>
            )}
          </div>
        )
      )}
      {modalOpen && (
        <LimitReachedModal
          dispatch={dispatch}
          id={id}
          entity={entity}
          history={history}
          handleCloseModal={() => setModalOpen(false)}
          isModalOpen={modalOpen}
          collectionName={entity.name}
        />
      )}
    </div>
  )
}

export default withStyles(styles)(CourseView)
